import { DialogTitleProps, DialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogTitleStyled = styled(DialogTitle)<DialogTitleProps>(({ theme }) => ({
  '&.MuiDialogTitle-root': {
    padding: `0 ${theme.spacing(2)} ${theme.spacing(2)} 0`,
    '& h2': {
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
}));
